import React from 'react';

export type DatevCostCenter = { id: string; code: string; name: string; active: boolean };

/** Kostenstellen für die Auswahl am Beleg; leer, solange DATEV nicht aktiv ist. */
export function useDatevCostCenters(enabled: boolean): DatevCostCenter[] {
  const [list, setList] = React.useState<DatevCostCenter[]>([]);
  React.useEffect(() => {
    if (!enabled) {
      setList([]);
      return;
    }
    let cancelled = false;
    fetch('/api/datev/cost-centers', { credentials: 'include' })
      .then((res) => (res.ok ? res.json() : { costCenters: [] }))
      .then((d) => {
        if (!cancelled) setList(Array.isArray(d?.costCenters) ? d.costCenters : []);
      })
      .catch(() => {
        if (!cancelled) setList([]);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return list;
}
